import React from 'react';

export const IcoEmpresa = ({ width = '24', height = '24', style = {}, ...props }) => {
  return (
    <svg 
      className="icon-empresa" 
      viewBox="0 0 23 21" 
      {...props} 
      style={{ ...style, fill: 'none' }}
      width={width} 
      height={height}
    >
      <path 
        d="M1 19.5158H22M2.61538 1.25488V19.5158M13.9231 1.25488V19.5158M20.3846 5.8201V19.5158M5.84615 5.05923H6.65385M5.84615 8.10271H6.65385M5.84615 11.1462H6.65385M9.88462 5.05923H10.6923M9.88462 8.10271H10.6923M9.88462 11.1462H10.6923M5.84615 19.5158V16.0918C5.84615 15.4618 6.38892 14.9505 7.05769 14.9505H9.48077C10.1495 14.9505 10.6923 15.4618 10.6923 16.0918V19.5158M1.80769 1.25488H14.7308M13.9231 5.8201H21.1923M17.1538 9.62445H17.1625V9.63256H17.1538V9.62445ZM17.1538 12.6679H17.1625V12.676H17.1538V12.6679ZM17.1538 15.7114H17.1625V15.7195H17.1538V15.7114Z" 
        stroke="currentColor" 
        strokeWidth="2" // Aumentado de 1.5 para 2
      />
    </svg>
  );
};